<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@import 'normalize.css/normalize.css';
@import './style/index.css';
@import './style/custom.css';
.el-upload-list{
  display: none ;
}
.el-collapse-item__content span{
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue